import React from "react";

import { func, object } from "prop-types";
import { Formik, Form, Field } from "formik";
import { Row, Col } from "reactstrap";

import { ButtonWithSpinner } from "../../../../components/common";
import UploadFileScoreCards from "../../../../components/formik/uploadScoreCard/UploadFileScoreCards";
import { SCORECARD_UPLOAD_SUPPORTED_FORMATS } from "../../constants/formValidations";
import { useSelector } from "react-redux";
import { uploadScoreCardsIsLoadingSelector } from "../../selectors";

const UploadScoreCardForm = ({ handleSubmit, initialValues, disabled }) => {
 const isLoading = useSelector(uploadScoreCardsIsLoadingSelector);
  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialValues}
      enableReinitialize
    >
      <Form className="upload-score-card-form" name="uploadForm">
        <div className="upload-score-card-main-container">
          <div>Upload a score card</div>
          <Row>
            <Col className="limited-input-characters" lg={12}>
              <Field
                name="scFile"
                accept={SCORECARD_UPLOAD_SUPPORTED_FORMATS}
                component={UploadFileScoreCards}
                key={initialValues.randomNum}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <ButtonWithSpinner
                className="upload-score-card-button"
                text="Upload"
                outline
                type="submit"
                loading={isLoading}
                disabled={disabled}
              />
            </Col>
          </Row>
        </div>
      </Form>
    </Formik>
  );
};

UploadScoreCardForm.propTypes = {
  handleSubmit: func.isRequired,
  initialValues: object.isRequired,
};

export default UploadScoreCardForm;



// WEBPACK FOOTER //
// ./src/features/score-card/components/upload-score-card-form/UploadScoreCardForm.jsx